module.exports = __webpack_public_path__ + "img/tr-signboard-not-printed-icon.fb5521d3.svg";